module.exports = __webpack_public_path__ + "img/prioritas_sameday.7fad9b37.png";